import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import '../../../../app/assets/stylesheets/mcor.scss';
import { fetchMultiContractRelationAction } from '../actions';

import MultiContractOrgRelationsCreateForm from './MultiContractOrgRelationsCreateForm';
import MultiContractOrgRelationsList from './MultiContractOrgRelationsList';
class MultiContractOrgRelationsIndex extends Component {
  render() {
    return (
      <div className="multi_contract_index">
        <h1>Multi contract organizations</h1>
        <div>*Primary Organization is typically Health Plan or Core Products</div>
        <div>*Secondary Organization is typically EMS or Chronic Care</div>
        <MultiContractOrgRelationsCreateForm
          hasBillingAccess={this.props.hasBillingAccess}
        />
        <MultiContractOrgRelationsList
          multiContractOrgRelations={this.props.multiContractOrgRelations}
          newMultiContractOrgRelations={this.props.newMultiContractOrgRelations}
          hasBillingAccess={this.props.hasBillingAccess}
        />
      </div>
    );
  }
}

MultiContractOrgRelationsIndex.propTypes = {
  fetchMultiContractRelationAction: PropTypes.func,
  errors:                           PropTypes.array,
  notice:                           PropTypes.string,
  multiContractOrgRelations:        PropTypes.array,
  newMultiContractOrgRelations:     PropTypes.array,
  hasBillingAccess:                 PropTypes.bool
};

const mapStateToProps = state => ({
  newMultiContractOrgRelations: state.mcorReducer.newMultiContractOrgRelations,
  errors:                       state.mcorReducer.errors,
  notice:                       state.mcorReducer.notice
});

const mapDispatchToProps = { fetchMultiContractRelationAction };

export default connect(mapStateToProps, mapDispatchToProps)(MultiContractOrgRelationsIndex);
